import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("cookie-consent");
        if (!consent) {
            // Show banner after a short delay for better UX
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleDismiss = () => {
        localStorage.setItem("cookie-consent", "true");
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background border-t shadow-lg animate-in slide-in-from-bottom duration-500">
            <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="text-sm text-muted-foreground text-center sm:text-left flex-1">
                    <p>
                        Questo sito utilizza cookie tecnici per garantire il corretto funzionamento e migliorare l&apos;esperienza di navigazione.
                        Non utilizziamo cookie di profilazione. Per saperne di più, consulta la nostra{" "}
                        <Link to="/cookie-policy" className="text-primary hover:underline font-medium">
                            Cookie Policy
                        </Link>.
                    </p>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                    <Button onClick={handleDismiss} size="sm" className="whitespace-nowrap">
                        Ho capito
                    </Button>
                    <Button
                        variant="ghost"
                        size="icon"
                        className="h-8 w-8 sm:hidden"
                        onClick={handleDismiss}
                        aria-label="Chiudi banner"
                    >
                        <X className="h-4 w-4" />
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
